import type { AppProps } from 'next/app'

import '../styles.css'
import ProgressBar from '../components/global/ProgressBar'
import dynamic from 'next/dynamic'
import Root from '../components/_root'

const TokenProvider = dynamic(() =>
  import('../contexts/TokenContext').then((mod) => mod.TokenProvider)
)
const Wallet = dynamic(() => import('../components/global/Wallet').then((mod) => mod.Wallet))

function App({ Component, pageProps }: AppProps): any {
  return (
    <Wallet>
      <TokenProvider>
        <ProgressBar />
        <Root Component={Component} pageProps={pageProps} />
      </TokenProvider>
    </Wallet>
  )
}

export default App
